<template>
  <div class="cityLinkage">
    <div class="selectItem">
      <span class="selectItemName">省/市/自治区：</span>
      <el-select v-model="provinceValue" clearable placeholder="请选择" @change="changeProvinceEvent">
        <el-option v-for="item in provinceList" :key="item.areaId" :label="item.areaName" :value="item.areaId">
        </el-option>
      </el-select>
    </div>
    <div class="selectItem">
      <span class="selectItemName">地市/州/盟：</span>
      <el-select v-model="cityValue" clearable placeholder="请选择" @change="changeCityEvent">
        <el-option v-for="item in cityList" :key="item.areaId" :label="item.areaName" :value="item.areaId">
        </el-option>
      </el-select>
    </div>
    <div class="selectItem">
      <span class="selectItemName">区/县级市/县：</span>
      <el-select v-model="areaValue" clearable placeholder="请选择" @change="changeAreaEvent">
        <el-option v-for="item in areaList" :key="item.areaId" :label="item.areaName" :value="item.areaId">
        </el-option>
      </el-select>
    </div>
  </div>
</template>
<script>
export default {
  name: "cityLinkage",
  data() {
    return {
      provinceList: [],
      cityList: [],
      areaList: [],
      // 省级code
      provinceValue: "",
      // 市级code
      cityValue: "",
      // 区级code
      areaValue: "",
      initCityCode: {
        type: 1,
        pid: 0,
      },
    };
  },
  watch: {
    // 搜索按钮状态切换
    '$store.state.productSearch.querytype': {
      handler(newVal, oldVal) {
        console.log(newVal,oldVal);
        if(newVal == 2){
          this.provinceValue = '';
          this.cityValue = '';
          this.areaValue = ''
        }
      },
      deep:true
    },
  },
  mounted() {
    //  初始化省市区信息
    this.getCityInfo(this.initCityCode);
  },
  methods: {
    // 获取省市区信息
    getCityInfo(sendJson) {
      this.$http
        .get(this.$const.common.getCityCode, sendJson)
        .then((res) => {
          //   console.log("省市区信息：", res);
          if (res.code == 200) {
            switch (this.initCityCode.type) {
              case 1:
                // 省级
                this.provinceList = res.data;
                break;
              case 2:
                // 市级
                this.cityList = res.data;
                this.areaList = [];
                break;
              case 3:
                // 县级
                this.areaList = res.data;
                break;
            }
          } else {
            this.$message.success(this.$PubText.getInfoFail);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.success(this.$PubText.InterfaceFail);
        })
        .finally((cms) => {
          // console.log(cms);
        });
    },
    // 切换省级
    changeProvinceEvent(value) {
      if (value.length == 0) {
        this.provinceValue = "";
        this.cityValue = "";
        this.areaValue = "";
        this.cityList = [];
        this.areaList = [];
        var sendData = {
          type: 2,
          value: "",
        };
      } else {
        this.initCityCode.type = 2;
        this.initCityCode.pid = value;
        this.cityValue = "";
        this.areaValue = "";
        var sendData = {
          type: 2,
          value: value,
        };
        this.getCityInfo(this.initCityCode);
      }
      this.$emit("cityValue", sendData);
    },
    // 切换市级
    changeCityEvent(value) {
      if (value.length == 0) {
        this.areaValue = "";
        this.areaList = [];
        var sendData = {
          type: 2,
          value: this.provinceValue,
        };
      } else {
        this.initCityCode.type = 3;
        this.initCityCode.pid = value;
        this.areaValue = "";
        var sendData = {
          type: 3,
          value: value,
        };
        this.getCityInfo(this.initCityCode);
      }
      this.$emit("cityValue", sendData);
    },
    // 切换区级
    changeAreaEvent(value) {
      if (value.length == 0) {
        var sendData = {
          type: 3,
          value: this.cityValue,
        };
      } else {
        var sendData = {
          type: 4,
          value: value,
        };
      }

      this.$emit("cityValue", sendData);
    },
  },
};
</script>
<style lang="scss" scoped>
.cityLinkage /deep/ .el-input__inner {
  height: 32px !important;
}

.cityLinkage {
  margin: 0 5px;

  .selectItem {
    margin: 8px auto;

    .selectItemName {
      display: inline-block;
      width: 100px;
      text-align: right;
      padding-right: 10px;
    }
  }
}
</style>
